// Desc: This is the theme for the Windroos website
import { createTheme } from "@mui/material";
import { COLORS } from "./tokens";

const WindroosTheme = createTheme({
  root: {
    maxWidth: 645,
    background: "rgba(0,0,0,0.5)",
    margin: "20px",
  },

  palette: {
    footer: {
      icon: "#fff",
    },

    rood: {
      main: COLORS.red,
    },
    oranje: {
      main: COLORS.orange,
    },
    blauw: {
      main: COLORS.blue,
    },
    lichtblauw: {
      main: COLORS.lightBlue,
    },
  },
  typography: {
    fontFamily: "Poppins, sans-serif",
    h1: {
      fontFamily: "windroos, sans-serif",
      color: COLORS.red,
    },
    h3: {
      fontFamily: "windroos, sans-serif",
      color: COLORS.blue,
    },
    h4: {
      fontFamily: "windroos, sans-serif",
      color: COLORS.blue,
    },

    h5: {
      fontFamily: "windroos, sans-serif",
      color: COLORS.blue,
    },
    h6: {
      fontFamily: "windroos, sans-serif",
    },
  },
  customfont: {
    main: "windroos, sans-serif",
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: COLORS.lightBlue,
        },
        typography: {
          fontFamily: "windroos, sans-serif",
          color: COLORS.orange,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "windroos, sans-serif",
          fontSize: "1.1rem",
          margin: "0.7rem",
          color: COLORS.orange,
        },
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          backgroundColor: COLORS.blue,
          verticalAlign: "top",
          marginTop: "2px",
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          color: "#fff",
          "&.Mui-selected": {
            color: COLORS.orange,
          },
          verticalAlign: "top",
          marginTop: "2px",
        },
        label: {
          fontFamily: "Windroos, sans-serif",
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: COLORS.orange,
          fontFamily: "windroos, sans-serif",
        },
      },
    },
  },
});

export default WindroosTheme;
